<template>

  <div class="static-field">
    <div class="label">{{ label }}</div>
    <div class="value">
      <slot></slot>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'static-field',

    props: [ 'label' ]
  }
</script>

<style scoped lang="scss">

  @import '../../../assets/variables';

  .static-field {
    position: relative;
    padding-top: 12px;
    margin-top: 4px;

    .label {
      height: 20px;
      line-height: 20px;
      transform: translateY(-10px) scale(0.75);
      transform-origin: top left;
      left: 0px;
      right: auto;
      position: absolute;
      opacity: .75;
    }

    .value {
      flex: 1 1 auto;
      line-height: 20px;
      padding: 8px 0 8px;
      max-width: 100%;
      min-width: 0px;
      width: 100%;
    }
  }

</style>
